import { FileUploadListener } from './../classes/FileUploadListener';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { OwnListService } from '../own-list.service';
import { Global } from '../classes/Global';
import { StorageHelper } from '../helpers/StorageHelper';
import { StringHelper } from '../helpers/StringHelper';

@Component({
  selector: 'app-import-vudu-lib',
  templateUrl: './import-vudu-lib.component.html',
  styleUrls: ['./import-vudu-lib.component.scss'],
  providers: [ OwnListService ]
})
export class ImportVuduLibComponent extends BaseComponent implements OnInit, FileUploadListener {

  MAX_FILE_SIZE_BYTES = 10485760; // 10MB in bytes

  @ViewChild('browseInput', {static: false}) browseInput;
  pages: number = 4;
  currentPageNo = 0;
  @Output() onClose = new EventEmitter();
  @Output() onNext = new EventEmitter<number>();

  isUploading = false;
  uploadSuccessful = true;
  percentage = "0";
  successCount = 0;
  skippedCount = 0;
  unknownCount = 0;
  uploadErrorMessage = "";
  responseMessage = "";

  moviesOn = true;
  tvOn = false;
  fileOK = false;
  invalidFile = false;
  fileTooBig = false;

  errorMessage = "";
  file;
  csvContent: string = "";

  constructor(
    private ownlistService: OwnListService
  ) {
    super();
  }

  ngOnInit() {
    // Pre-select based on current media type
    const currentMedia = Global.getMediaTypeForWishlistRequest();
    if (currentMedia === Global.SEASONS || currentMedia === Global.TV) {
      this.moviesOn = false;
      this.tvOn = true;
    }
  }

  next() {

    if (!this.moviesOn && !this.tvOn) {
      this.errorMessage = this.getString("importVuduPage3Checkbox");
      return;
    }

    if (this.currentPageNo === 2) {
      // This is the upload screen - validate file before proceeding
      if (!this.file) {
        this.invalidFile = true;
        return;
      }
      
      if (!this.fileOK) {
        return;
      }

      // Start upload process
      this.isUploading = true;
      this.uploadVuduLibrary();
      return;
    }

    this.slideToNextPage();
  }

  uploadVuduLibrary() {
    // Determine media type
    const mediaType = this.moviesOn ? 'movies' : 'tv';

    // Create Blob from CSV content
    const blob = new Blob([this.csvContent], { type: 'text/csv' });

    this.ownlistService.importMediaLibrary(
      blob,
      this, // FileUploadListener
      Global.getCountry(),
      Global.VUDU, // Use Vudu store
      mediaType, // Send mediaType as separate parameter
      StorageHelper.getInstance().get(StorageHelper.keys.sessionToken)
    ).subscribe(res => {
      this.isUploading = false;
      this.uploadSuccessful = false;
      
      let parsedRes = res;
      try {
        // Try to parse if response is string
        if (typeof res === 'string') {
          parsedRes = JSON.parse(res);
        }
      } catch (e) {
        // Already parsed or parse error
      }
      
      if (parsedRes) {
        if (parsedRes["status"] == "success") {
          this.uploadSuccessful = true;
          this.responseMessage = parsedRes["message"] || this.getString("importSuccessful");
          
          if (parsedRes["additionalInfo"]) {
            this.successCount = parsedRes["additionalInfo"]["addedCount"] || 0;
            this.skippedCount = parsedRes["additionalInfo"]["skippedCount"] || 0;
            this.unknownCount = parsedRes["additionalInfo"]["unknownCount"] || 0;
          }
        }
        else {
          this.uploadErrorMessage = parsedRes["message"] || this.getString("error");
          this.responseMessage = parsedRes["message"] || this.getString("error");
        }
      }
      this.slideToNextPage();
    }, err => {
      this.isUploading = false;
      this.uploadSuccessful = false;
      this.uploadErrorMessage = this.getString("error");
      this.responseMessage = this.getString("error");
      this.slideToNextPage();
    });
  }

  back() {
    this.currentPageNo--;

    const content = document.getElementsByClassName("content-vudu")[0];
    let w = content.clientWidth;
    const interval = setInterval(() => {
      if (w > 0) {
        const pixelsToScroll = w > 40 ? 40 : w;
        w -= pixelsToScroll;
        const element = document.getElementsByClassName("slide-container-vudu")[0];
        if (element && element.scrollBy) {
          element.scrollBy(-pixelsToScroll, 0);
        }

      }
      else {
        clearInterval(interval);
      }
    }, 25);
  }

  slideToNextPage() {
    if (this.currentPageNo < this.pages - 1) {
      this.currentPageNo++;
    }

    this.onNext.emit(this.currentPageNo);
    const content = document.getElementsByClassName("content-vudu")[0];
    if (!content) { return; }

    let w = content.clientWidth;
    const interval = setInterval(() => {
      if (w > 0) {
        const pixelsToScroll = w > 40 ? 40 : w;
        w -= pixelsToScroll;
        const element = document.getElementsByClassName("slide-container-vudu")[0];
        if (element && element.scrollBy) {
          element.scrollBy(pixelsToScroll, 0);
        }

      }
      else {
        clearInterval(interval);
      }
    }, 25);
  }

  close() {
    this.onClose.emit();
  }

  cbMoviesChanged(value) {
    // Exclusive selection - only one can be active
    if (value) {
      this.moviesOn = true;
      this.tvOn = false;
    }
    this.errorMessage = "";
  }

  cbTVChanged(value) {
    // Exclusive selection - only one can be active
    if (value) {
      this.tvOn = true;
      this.moviesOn = false;
    }
    this.errorMessage = "";
  }

  chooseFile() {
    this.browseInput.nativeElement.click();
    return false;
  }

  handleSelectedLocalFiles(e) {

    this.fileOK = false;
    this.invalidFile = false;
    this.fileTooBig = false;

    const files: FileList = (e.srcElement || e.target).files;

    const filesArray = [];
    for (let i = 0; i < files.length; i++) {
      filesArray.push(files.item(i));
    }
    if (filesArray.length > 0){
      const selectedFile = filesArray[0];

      // Check file size
      if (selectedFile.size > this.MAX_FILE_SIZE_BYTES) {
        this.fileTooBig = true;
        this.browseInput.nativeElement.value = "";
        return;
      }

      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        const fileContent = fileReader.result;
        // Simple validation: Check if first line contains "Movie,"
        const content = fileContent.toString();
        const firstLine = content.split('\n')[0] || '';
        
        if (firstLine.indexOf('Movie,') !== -1 || firstLine.indexOf('movie,') !== -1) {
          this.fileOK = true;
          this.csvContent = content;
        }
        else {
          this.invalidFile = true;
        }
      };
      fileReader.readAsText(selectedFile);
      this.file = selectedFile;
    }
    this.browseInput.nativeElement.value = "";
  }

  onProgress(file: any, progressPercentage: number) {
    this.percentage = progressPercentage.toFixed(0);
  }

  getSuccessCountText(): string {
    return StringHelper.format(this.getString('importVuduPage4SuccessText1'), "" + this.successCount);
  }

  getSkippedCountText(): string {
    return StringHelper.format(this.getString('importVuduPage4SkippedText'), "" + this.skippedCount);
  }

  getUnknownCountText(): string {
    return StringHelper.format(this.getString('importVuduPage4UnknownText'), "" + this.unknownCount);
  }

  getErrorMessageText(): string {
    return StringHelper.format(this.getString('importPage4ErrorText2'), "" + this.uploadErrorMessage);
  }

}
